import { CityCreatePage } from "@/features/geolocation/page/CityCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/city/create")({
  component: CityCreatePage,
});
